module.exports = __webpack_public_path__ + "img/partners1.487422d9.jpg";